export function calculateLineHeadPosition (ev, element) {
  const progressWidth = element.getBoundingClientRect().width
  const leftPosition = ev.target.getBoundingClientRect().left
  let pos = (ev.clientX - leftPosition) / progressWidth

  try {
    // eslint-disable-next-line no-useless-escape
    if (!ev.target.className.match(/^ar\-line\-control/)) {
      return
    }
  } catch (err) {
    return
  }

  pos = pos < 0 ? 0 : pos
  pos = pos > 1 ? 1 : pos

  return pos
}

export function convertTimeMMSS (seconds) {
  seconds = parseInt(seconds)
  if(Number.isNaN(seconds))return '00:00'
  let sec = padLeft(seconds % 60, 2)
  let min = padLeft(Math.floor(seconds / 60), 2)
  return `${min}:${sec}`
  // return new Date(seconds * 1000).toISOString().substr(14, 5)
}

function padLeft(str, len) {
  // 避免 str 為數字
  str = String(str)
  return str.length >= len ? str : new Array(len - str.length + 1).join('0') + str
}

export function fileToDataURL(file){
  let cancel = false
  let _resolve = null
  let p = new Promise((resolve, reject)=>{
    _resolve = resolve
    let reader = new FileReader()
    reader.onload = function(e){
      if(!cancel){
        resolve(e.target.result)
      }
    }
    reader.readAsDataURL(file)
  })
  p.cancel = ()=>{
    cancel = true
    _resolve()
  }
  return p
}
